import React from "react";
import { MORE_LINKS } from "../data/links";
import * as _ from "lodash";
import { useTranslations } from "../../../hooks/use-translations";
import { LinksSection } from "./links-section";
import { useLanguage } from "../../../hooks/use-language";

/**
 * Renders a component with a links list from MORE_LINKS constant.
 * This list of links is located in the footer of the app.
 *
 * @returns {React.ReactElement} The MoreLinks component.
 */
export const MoreLinks = () => {
	const lang = useLanguage();
	const texts = useTranslations({ section: "footer", lang: lang });

	return (
		<LinksSection title={_.get(texts, "sobre_makemake.titulo") || 'Más sobre MakeMake'} linksData={MORE_LINKS}/>
	);
};
